'use strict';

import { Cloudflare } from '../api/Cloudflare';
import {ProjectLogs} from "../components/ProjectLogs";
import { getCurrentDateTime, getDateAfarFromCurrent, getUrlParam } from '../../functions';
import {BmbyMode} from "../mode/BmbyMode";

const axios = require('axios').default;

export function getSettings () {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/settings/${config.projectGuid}`);
            localStorage.setItem('settings', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('settings'));
        } finally {
            ProjectLogs.timerStopFor('api_settings');
            resolve(response);
        }
    });
}

export function getCommonAssets () {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/common-assets/${config.projectGuid}`);
            localStorage.setItem('common-assets', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('common-assets'));
        } finally {
            resolve(response);
        }
    });
}

export function getAmenities () {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/amenities/${config.projectGuid}`);
            localStorage.setItem('amenities', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('amenities'));
        } finally {
            resolve(response);
        }
    });
}

export function getProps () {
    const marketingId = getUrlParam('id');
    if (marketingId) {
        return getMarketingProps(marketingId);
    } else {
        return new Promise(async (resolve) => {
            let response;
        
            try {
                let url =`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/props/${config.projectGuid}`;
                if(BmbyMode.active) url+='?status=bmby';
                response = await axios.get(url);
                localStorage.setItem('props', JSON.stringify(response));
            } catch (e) {
                response = JSON.parse(localStorage.getItem('props'));
            } finally {
                ProjectLogs.timerStopFor('api_props');
                resolve(response);
            }
        });
    }
}

export function getBuildingShape () {
    return new Promise(async (resolve) => {
        let response;
        try {
            let url =`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/get-building-shape/${config.projectGuid}`;
            response = await axios.get(url);
            localStorage.setItem('buildingShape', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('buildingShape'));
        } finally {
            resolve(response);
        }
    });
}

export function setBuildingShape (data) {
    return axios.post(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/set-building-shape/${config.projectGuid}`,data);
}

export function getMarketingProps (id) {
    return new Promise(async (resolve) => {
        let response;
        
        try {
            let url =`${config.apiDomain}/api/properties/marketing/${id}`;
            if(BmbyMode.active) url+='?status=bmby';
            response = await axios.get(url);
            response.data.forEach(apt => {
                apt.buildingEngineId = apt.engineId.split('_')[0];
                apt.assets = {
                    plan2D: ''
                }
            });
            localStorage.setItem('marketingProps', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('marketingProps'));
        } finally {
            resolve(response);
        }
    });
}

export function getProp (propId) {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/props/${config.projectGuid}?propId=${propId}`);
        } catch (e) {
            response = {data: []};
        } finally {
            resolve(response);
        }
    });
}

export function getSales(daysAgo) {
    return new Promise(async (resolve) => {
        let response;
        try {
            const endDate = getCurrentDateTime('YYYY-MM-DD', 'UTC')
            const startDate = getDateAfarFromCurrent(daysAgo);
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/sales/${config.projectGuid}?startDate=${startDate}&endDate=${endDate}`);
        } catch (e) {
            response = null;
        } finally {
            resolve(response);
        }
    });
}

export function getSpecifications() {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/specifications/${config.projectGuid}`);
        } catch (e) {
            response = null;
        } finally {
            resolve(response);
        }
    });
}

/**
 * Get dictionary json file from CDN repository
 * Returns promise
 */
export const getDictionary = () => {
    return new Promise(async (resolve) => {
        let response;
        try {
            let url;
            if (Cloudflare.version) {
                url = `${config.cdnRepository}/${config.projectFolder}/config/dictionary.json?v=${Cloudflare.version}`;
                if (window.ld && window.ld[0])
                    url += window.ld[0].version;
            } else {
                url = `${config.cdnRepository}/${config.projectFolder}/config/dictionary.json`;
                if (window.ld && window.ld[0])
                    url += `?v=${window.ld[0].version}`;
            }
            response = await axios.get(url, {headers: {'Content-Type': 'application/json'}});
            localStorage.setItem('dictionary', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('dictionary'));
        } finally {
            resolve(response);
        }
    });
};

export const sendUserID = (data) => {
    axios.post(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/register-user/${config.projectGuid}`,data);
};

export const releasePayment = (data) => {
    axios.post(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/payment/${config.projectGuid}`,data);
};

export const sendLogs = (data, type) => {
    if (type === 'error' && config.features?.errorLogs === false)
        return;

    axios.post(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/log/${config.projectGuid}`, {type, data});
};

const getPoi = () => {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/poi/${config.projectGuid}`);
            localStorage.setItem('poi', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('poi'));
        } finally {
            resolve(response);
        }
    });
};

const getPoiCategories = () => {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/poicategories/${config.projectGuid}`);
            localStorage.setItem('poi-categories', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('poi-categories'));
        } finally {
            resolve(response);
        }
    });
};

const getAboutData = () => {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/about/${config.projectGuid}`);
            localStorage.setItem('about', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('about'));
        } finally {
            resolve(response);
        }
    });
};

export const getGalleryData = () => {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/gallery/${config.projectGuid}`);
            localStorage.setItem('gallery', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('gallery'));
        } finally {
            resolve(response);
        }
    });
};

export const getContactsData = () => {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/contacts/${config.projectGuid}`);
            // response = await axios.get('https://mbeat.bmby.com/api/dreamsv3/contacts/AD2E4237-1B57-46C7-82EF-2499B9817160');
            localStorage.setItem('contacts', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('contacts'));
        } finally {
            resolve(response);
        }
    });
};

export const getDocuments = () => {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/documents/${config.projectGuid}`);
            localStorage.setItem('documents', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('documents'));
        } finally {
            resolve(response);
        }
    });
};

export const getLoaderData = () => {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/loader/${config.projectGuid}`);
            localStorage.setItem('loader', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('loader'));
        } finally {
            ProjectLogs.timerStopFor('api_loader');
            resolve(response);
        }
    });
};

export const getWSToken = () => {
    return new Promise(async (resolve) => {
        let response;
        try {
            response = await axios.get(`${config.apiDomain}${config.apiEndpoint}${config.apiVersion}/wstoken/${config.projectGuid}`);
            localStorage.setItem('wstoken', JSON.stringify(response));
        } catch (e) {
            response = JSON.parse(localStorage.getItem('wstoken'));
        } finally {
            resolve(response);
        }
    });
};

//essential API data
export function getCrmData () {
    return Promise.all([getSettings(), getProps(), getDictionary()]);
}

// poi API data
export function getPoiData () {
    return Promise.all([getPoi(), getPoiCategories()]);
}

export function getWidgetsData () {
    return Promise.all([getAboutData(), getGalleryData(), getPoi(), getPoiCategories()]);
}
